import React, { PureComponent } from 'react';
import { View, StyleSheet } from 'react-native';

import { rem } from 'design-system';
import Text from 'design-system/Text';

import BroadbandFilterBox from '../../broadband/BroadbandFilterBox';
import RadioForm from '../../broadband/RadioForm';

const tariff_type = [
  { label: 'All', value: 0 },
  { label: 'Fixed only', value: 1 },
  { label: 'Variable only', value: 2 },
];

// const tariff_features = [
//   { label: 'No exit fees', value: 0 },
//   { label: 'Warm home discount', value: 1 },
//   { label: 'Special offers and exclusives', value: 2 },
//   { label: 'Green  tariffs', value: 2 },
// ];

const show_me = [
  { label: 'Deals you can switch me to', value: 0 },
  { label: 'All deals in the market', value: 1 },
];

class EnergyFilters extends PureComponent {
  state = this.props.state;

  // _onClosed = () => {
  //   this.props.onClosed();
  // };

  _onShowMe = (data) => {
    this.props.onFiltering('show_me', data, { ...this.state, showMe: data });
  };

  // _onChangeTariffFeatures = (data) => {
  //   this.props.onFiltering('tariff_features', {
  //     ...this.state,
  //     tariffFeatures: data,
  //   });
  // };

  _onChangeTariffType = (data) => {
    this.props.onFiltering('tariff_type', data, {
      ...this.state,
      tariffType: data,
    });
  };

  _onGreenChange = (data) => {
    this.setState({ isGreenProvider: data });
    this.props.onFiltering('isGreeen', data, {
      ...this.state,
      isGreenProvider: data,
    });
  };

  _renderTariffType = () => (
    <View>
      <Text Text-16 Gray-70 style={styles.filterTitle}>
        Tariff type
      </Text>
      <RadioForm
        options={tariff_type}
        initial={this.props.state.tariffType}
        onPress={this._onChangeTariffType}
      />
    </View>
  );

  // _renderTariffFeatures = () => (
  //   <View>
  //     <Text Text-16 Gray-70 style={styles.filterTitle}>
  //       Tariff features
  //     </Text>
  //     <RadioForm
  //       options={tariff_features}
  //       initial={this.props.state.tariffFeatures}
  //       onPress={this._onChangeTariffFeatures}
  //     />
  //   </View>
  // );

  _renderShowMe = () => (
    <View>
      <Text Text-16 Gray-70 style={styles.filterTitle}>
        Show me
      </Text>
      <RadioForm
        options={show_me}
        initial={this.props.state.showMe}
        onPress={this._onShowMe}
      />
    </View>
  );

  _renderGreenEnergy = () => {
    const { isGreenProvider } = this.state;
    return (
      <View>
        <Text Text-16 Gray-70 style={styles.filterTitle}>
          Green Energy
        </Text>
        <BroadbandFilterBox
          value={isGreenProvider}
          onValueChange={this._onGreenChange}
          label="Green Tariffs only"
        />
      </View>
    );
  };

  render() {
    return (
      <View style={styles.container}>
        {this._renderTariffType()}
        {this._renderShowMe()}
        {this._renderGreenEnergy()}
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    paddingBottom: rem(16),
  },
  filterTitle: {
    marginTop: rem(16),
    marginBottom: rem(8),
    paddingHorizontal: rem(16),
  },
});

export default EnergyFilters;
